import * as React from 'react';
import './checkbox2.less';
import { LoggerHelper } from 'ff-shared-components-core';

// [COMPONENT USAGE]

/* <Checkbox id="UniqueID" handleChange={this.handler} isChecked={checkedState}  appearance={CheckboxAppearances.default}/> */

export enum CheckboxAppearance {
	default,
	whiteOnMobile,
}

export interface Checkbox2Props {
	/**sets a unique identifier for the checkbox */
	id: string;
	/**sets the text of the label */
	labelText?: string;
	/** Pre set CheckBox as checked */
	isChecked?: boolean;
	/** Pre set CheckBox as disabled */
	disabled?: boolean;
	/**sets card appearance */
	appearance?: CheckboxAppearance;
	/** Set the event that should be handle when checkbox is clicked */
	handleChange?(event: any): void;
}

export class Checkbox2 extends React.Component<Checkbox2Props> {
	render(): JSX.Element {
		const { labelText, isChecked, id, handleChange, disabled } = this.props;

		return (
			<div className={`it-checkbox${disabled === true ? ' disabled' : ''}${this.getAppearanceClass()}`}>
				<div className="checkbox-container">
					<span className="input-container">
						<input
							type="checkbox"
							className="checkbox-input"
							id={id}
							disabled={disabled}
							defaultChecked={isChecked}
							onChange={
								!disabled
									? (event: any): void => {
											handleChange && handleChange(event);
									  }
									: undefined
							}
						/>
						<span className="checkbox-icon"></span>
					</span>
					{labelText && (
						<label htmlFor={id} className="checkbox-label">
							{labelText}
						</label>
					)}
				</div>
			</div>
		);
	}

	private readonly getAppearanceClass = (): string => {
		const { appearance } = this.props;

		if (appearance === CheckboxAppearance.whiteOnMobile) {
			return ' white-on-mobile';
		}

		return '';
	};
}
